<template>
  <el-container style="background: #F1F1F1;height: calc(100% - 45px);">
    <!-- 内容 -->
    <el-main style="height: 100%;    padding: 20px 0px 20px 20px;">
      <div class="column content" :style="{height:contentHeight+'px'}">
        <div class="row title">
          <span>输入需要翻译的英文文章,最多1万字.</span>
          <div class="row tran">
            <span>原文</span>
            <el-switch
              v-model="translation"
              :disabled="!textarea.trim().length>0"
              @change="onTranslationChange()"
            />
            <span>译文</span>
            <i v-if="isTran" class="el-icon-loading"></i>
          </div>
          <span
            style="display: flex;align-items: center;margin-left: 10px;cursor:pointer;"
            @click="rid='';transResult=[];textarea='';isEditor=true;translation=false;"
          >
            <svg
              t="1656087072582"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="17688"
              width="16"
              height="16"
              style="margin-right: 5px;"
            >
              <path
                d="M863.328262 481.340895l-317.344013 0.099772L545.984249 162.816826c0-17.664722-14.336138-32.00086-32.00086-32.00086s-31.99914 14.336138-31.99914 32.00086l0 318.400215-322.368714-0.17718c-0.032684 0-0.063647 0-0.096331 0-17.632039 0-31.935493 14.239806-32.00086 31.904529-0.096331 17.664722 14.208843 32.031824 31.871845 32.095471l322.59234 0.17718 0 319.167424c0 17.695686 14.336138 32.00086 31.99914 32.00086s32.00086-14.303454 32.00086-32.00086L545.982529 545.440667l317.087703-0.099772c0.063647 0 0.096331 0 0.127295 0 17.632039 0 31.935493-14.239806 32.00086-31.904529S880.960301 481.404542 863.328262 481.340895z"
                p-id="17689"
                fill="#333333"
              />
            </svg>
            添加
          </span>
          <span
            v-if="!isEditor && !translation"
            style="display: flex;align-items: center;margin-left: 10px;cursor:pointer;"
            @click="isEditor=true;transResult=[];"
          >
            <svg
              t="1656086513845"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="16608"
              width="12"
              height="12"
              style="margin-right: 5px;"
            >
              <path
                d="M984.772923 951.729231H39.227077a35.603692 35.603692 0 0 0-35.288615 36.115692c0 20.086154 15.675077 36.155077 35.288615 36.155077h949.444923a35.603692 35.603692 0 0 0 35.328-36.155077c-3.938462-16.029538-19.613538-36.115692-39.227077-36.115692zM35.328 843.303385H204.012308c7.876923 0 19.613538-4.017231 23.552-12.051693L808.172308 236.937846c15.714462-16.068923 15.714462-36.155077 0-52.224L643.426462 12.051692c-15.675077-16.068923-35.288615-16.068923-51.003077 0l-117.681231 120.477539L11.776 606.365538c-7.876923 8.034462-11.776 16.068923-11.776 24.103385v172.662154c0 8.034462 3.938462 20.086154 11.776 28.120615 3.938462 8.034462 15.675077 12.051692 23.552 12.051693zM615.975385 88.339692l117.68123 120.477539-66.678153 68.253538-117.720616-120.477538 66.717539-68.253539zM74.555077 646.537846L502.153846 208.817231l117.681231 120.477538L192.236308 767.015385H74.555077v-120.516923z"
                p-id="16609"
                fill="#333333"
              />
            </svg>
            编辑
            <span
              style="margin-left:5px;color: #ff5858;"
            >编辑原文后,译文将重新生成,以前所有保存的挖空、滑词将清除.</span>
          </span>
          <!-- 保存 带名称输入框 -->
          <el-popover v-if="rid===''" placement="bottom" width="200" trigger="click">
            <span slot="reference">
              <span
                v-if="translation"
                style="display: flex;align-items: center;margin-left: 10px;cursor:pointer;"
              >
                <svg
                  t="1656068826244"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="16407"
                  width="18"
                  height="18"
                  style="margin-right: 5px;"
                >
                  <path
                    d="M819.823 83.694H206.991c-67.703 0-122.588 54.885-122.588 122.588v612.833c0 67.703 54.885 122.588 122.588 122.588h612.833c67.703 0 122.588-54.885 122.588-122.588V206.282c-0.001-67.703-54.885-122.588-122.589-122.588z m-124.435 63.313v241.142H331.772V147.007h363.616z m185.787 672.274c0.027 33.765-27.323 61.158-61.088 61.185H207.133c-16.389 0-31.864-6.297-43.454-17.887s-18.039-26.91-18.039-43.298v-612.94c0.061-33.923 27.57-61.395 61.493-61.41h61.327v245.294c-0.05 33.771 27.286 61.187 61.057 61.237h367.888c33.853 0 61.299-27.387 61.299-61.237V144.931h61.206c33.872 0.036 61.301 27.524 61.265 61.396V819.281z"
                    fill="#e6e6e6"
                    p-id="16408"
                  />
                  <path
                    d="M574.817 329.936c17.483 0 31.656-14.173 31.656-31.656v-61.292c0-17.483-14.173-31.656-31.656-31.656s-31.656 14.173-31.656 31.656v61.292c0 17.483 14.173 31.656 31.656 31.656z"
                    fill="#e6e6e6"
                    p-id="16409"
                  />
                </svg>
                保存
              </span>
            </span>
            <div class="column" style="position: relative;">
              <span style="font-size:12px;color: #606060;margin-bottom: 5px;">请输入名称</span>
              <el-input v-model="newName" style="margin-bottom: 36px;" />
              <el-button
                type="success"
                style="position: absolute;right: 0px;bottom: 0px;"
                @click="onAdd()"
              >保存</el-button>
            </div>
          </el-popover>
          <!-- 保存 不带输入框 -->
          <span
            v-if="translation && rid!==''"
            style="display: flex;align-items: center;margin-left: 10px;cursor:pointer;"
            @click="onAdd()"
          >
            <svg
              t="1656068826244"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="16407"
              width="18"
              height="18"
              style="margin-right: 5px;"
            >
              <path
                d="M819.823 83.694H206.991c-67.703 0-122.588 54.885-122.588 122.588v612.833c0 67.703 54.885 122.588 122.588 122.588h612.833c67.703 0 122.588-54.885 122.588-122.588V206.282c-0.001-67.703-54.885-122.588-122.589-122.588z m-124.435 63.313v241.142H331.772V147.007h363.616z m185.787 672.274c0.027 33.765-27.323 61.158-61.088 61.185H207.133c-16.389 0-31.864-6.297-43.454-17.887s-18.039-26.91-18.039-43.298v-612.94c0.061-33.923 27.57-61.395 61.493-61.41h61.327v245.294c-0.05 33.771 27.286 61.187 61.057 61.237h367.888c33.853 0 61.299-27.387 61.299-61.237V144.931h61.206c33.872 0.036 61.301 27.524 61.265 61.396V819.281z"
                fill="#e6e6e6"
                p-id="16408"
              />
              <path
                d="M574.817 329.936c17.483 0 31.656-14.173 31.656-31.656v-61.292c0-17.483-14.173-31.656-31.656-31.656s-31.656 14.173-31.656 31.656v61.292c0 17.483 14.173 31.656 31.656 31.656z"
                fill="#e6e6e6"
                p-id="16409"
              />
            </svg>
            保存
          </span>
        </div>
        <!-- 原文 -->
        <div v-if="!translation" class="original-input">
          <el-input
            v-model="textarea"
            type="textarea"
            placeholder="请输入内容"
            maxlength="10000"
            style="height: 100%;"
            :disabled="!isEditor"
          />
        </div>
        <!-- 译文 -->
        <div v-else class="original-trans">
          <el-scrollbar class="scrollbar">
            <div v-for="(tr,index) in transResult" :key="index" :ref="index" class="row trans">
              <div class="word row" @mouseleave="isHollowDown=false;">
                <div v-for="(item, index1) in tr.list" :key="index1">
                  <el-tooltip
                    :ref="'tooltip'+index1"
                    effect="light"
                    placement="top-start"
                    :open-delay="500"
                    :disabled="!item.isSelect"
                    :hide-after="0"
                    :manual="item.translation"
                  >
                    <div slot="content">
                      <!-- 操作按钮 -->
                      <div v-if="!item.translation">
                        <!-- 挖空 -->
                        <svg
                          t="1656060704869"
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="1729"
                          width="16"
                          height="16"
                          style="margin-right:10px"
                          @click="onStyleType(1,item.value,index,index1)"
                        >
                          <path
                            d="M512 384l147.2 76.8L576 601.6s0 6.4-6.4 6.4l-12.8 19.2c-25.6 25.6-70.4 32-102.4 19.2-38.4-19.2-51.2-70.4-32-108.8v-6.4L512 384z"
                            fill="#707070"
                            opacity=".1"
                            p-id="1730"
                          />
                          <path
                            d="M224 832v-140.8L320 704l128 64 192-32 64-128L768 512l32-32V832h-576z"
                            fill="#707070"
                            opacity=".1"
                            p-id="1731"
                          />
                          <path
                            d="M492.8 742.4c-25.6 0-57.6-6.4-76.8-19.2-38.4-19.2-64-57.6-76.8-96-12.8-44.8-6.4-89.6 19.2-128l121.6-204.8 44.8-12.8 83.2 51.2 70.4-128-89.6-51.2 32-57.6 224 128-32 57.6-83.2-51.2-70.4 128 83.2 51.2 12.8 44.8-121.6 204.8c-19.2 38.4-57.6 64-96 76.8-12.8 0-32 6.4-44.8 6.4zM512 352L409.6 531.2c-12.8 25.6-12.8 51.2-6.4 76.8 6.4 25.6 25.6 44.8 44.8 57.6 19.2 12.8 51.2 19.2 70.4 12.8 25.6-6.4 44.8-25.6 57.6-44.8L678.4 448 512 352z"
                            fill="#707070"
                            p-id="1732"
                          />
                          <path
                            d="M896 928H128l-32-32v-192h64v160h704v-384h64V896z"
                            fill="#707070"
                            p-id="1733"
                          />
                        </svg>
                        <!-- 翻译 -->
                        <svg
                          t="1656060864478"
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="6575"
                          width="16"
                          height="16"
                          style="margin-right:10px"
                          @click="item.translation=true;windowType=1;onStyleType(2,item.value,index,index1);"
                        >
                          <path
                            d="M545.3 65c38.3 0 69.7 29.2 73.3 66.5l0.4 7.1v265.8h256.8c43 0 78.4 33 82.2 75.2l0.4 7.5v389.1c0 43.1-33 78.5-75.1 82.3l-7.5 0.3H486.6c-43.1 0-78.5-33-82.3-75.1l-0.3-7.5V619.4H138.2c-37.9 0-69.6-28.8-73.3-66.5l-0.3-7.1V138.6c0-38.3 29.2-69.6 66.5-73.2l7.2-0.4h407z m330.4 387.1H619v93.7c-0.1 38.3-29.2 69.7-66.6 73.2l-7.1 0.4h-93.7v256.8c0 17.5 13 32 29.8 34.6l5.1 0.4h389.2c17.5 0 32-13 34.5-29.8l0.4-5.1V487.1c0-19.3-15.5-35-34.9-35zM167.1 666.6l2.8-0.1c12.1 0 22.3 9.1 23.7 21.1 0.2 1.9 3.9 30.1 21.7 60.3 16.6 28.2 45.2 58.1 95.1 70.9l11.1 2.5h0.1c9.7 2.3 16.6 10.1 18.2 19.2l0.4 4.1-0.6 5.4c-2.1 9.4-9.7 16.6-19.2 18.2l-4 0.3-3.8-0.3h-0.1c-73.8-14.3-115.6-57.9-138.5-97.7-13.8-23.6-23.1-49.6-27.6-76.6V693.1l-0.2-2.8c0-10.4 6.7-19.7 16.7-22.8l4.2-0.9 2.7-0.1-2.7 0.1zM695.2 557c8.6 0 16.3 4.5 20.5 11.6l1.8 3.7 84.4 219.9 1.6 8.6c0 8.4-4.4 16.1-11.5 20.5l-3.8 1.9-8.5 1.6c-8.3 0-16.1-4.3-20.5-11.4l-1.9-3.9-18.1-47.5h-89.7l-18.7 47.6c-3.1 7.8-10 13.4-18.3 14.8l-4 0.3-8.7-1.7c-7.8-3.1-13.4-9.9-14.8-18.2l-0.3-4.1 1.7-8.8L673 572c3-7.8 9.8-13.4 18-14.8l4.2-0.2h0.1-0.1z m-0.3 89.7l-26.6 67.6h52.5l-25.9-67.6z m-149.6-534h-407c-12.5 0.1-23.2 9-25.5 21.3l-0.4 4.6v407.3c0 12.5 9 23.2 21.2 25.4l4.7 0.5h407.2c12.5-0.1 23.2-9 25.5-21.3l0.4-4.7V138.6c0-14.3-11.6-25.9-25.9-25.9h-0.2z m-205.6 75.7c13.2 0 23.8 10.7 23.8 23.8v27.7h77.8c20 0 36.3 16.2 36.3 36.3v75.2c0 20-16.3 36.3-36.3 36.3h-77.8v89.2c-0.6 12.8-11.1 22.8-23.9 22.8-12.8 0-23.3-10-23.9-22.8v-89.2H238c-20-0.1-36.3-16.3-36.3-36.4v-75.1c0.1-20 16.3-36.2 36.3-36.3h77.8v-27.7c0-13.1 10.7-23.8 23.9-23.8z m90.2 99.2h-66.4V340h66.3l0.1-52.4z m-114.1 0h-66.4V340h66.3l0.1-52.4zM714.2 139l1.8 0.1c29.3 2.3 71.2 13.9 106.8 40.9 33.1 25.2 60.4 64.2 65.2 120.8l0.7 12.4c0 11.9-8.1 21.7-19 24l-4.2 0.5h-0.7c-12.9 0-23.5-10.3-23.8-23.3-1.7-58.3-32.1-89.4-63.3-107-20-10.9-41.9-18-64.6-20.7l-0.9-0.1-4.5-0.8c-8.7-2.4-15.3-9.6-17-18.4l-0.4-4.5 0.1-1.9c1.1-12.4 11.5-21.9 23.8-22z m0 0"
                            fill="#707070"
                            p-id="6576"
                          />
                        </svg>
                        <!-- 例句 -->
                        <svg
                          t="1656220322544"
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="7368"
                          width="16"
                          height="16"
                          style="margin-right:5px"
                          @click="windowType=2;onStyleType(4,item.value,index,index1,item);"
                        >
                          <path
                            d="M915 556H334.782c-60 0-60-90 0-90H915c60 0 60 90 0 90z m-0.377 371H334.405c-60 0-60-90 0-90h580.218c60 0 60 90 0 90z m0-741H334.405c-60 0-60-90 0-90h580.218c60 0 60 90 0 90zM128 206c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64 35.346 0 64 28.654 64 64 0 35.346-28.654 64-64 64z m0 741c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64 35.346 0 64 28.654 64 64 0 35.346-28.654 64-64 64z m0-371c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64 35.346 0 64 28.654 64 64 0 35.346-28.654 64-64 64z"
                            fill="#707070"
                          />
                        </svg>
                        <!-- 分割线 -->
                        <svg
                          t="1656220382482"
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="7722"
                          width="16"
                          height="16"
                          style="margin-right:2px"
                        >
                          <path
                            d="M531.185456 943.532317c0 8.899694-6.493901 16.114003-14.503319 16.114003l-9.364275 0c-8.010441 0-14.504342-7.214309-14.504342-16.114003L492.81352 80.46666c0-8.898671 6.493901-16.114003 14.504342-16.114003l9.364275 0c8.009418 0 14.503319 7.215332 14.503319 16.114003L531.185456 943.532317z"
                            fill="#707070"
                          />
                        </svg>
                        <!-- 删除 -->
                        <svg
                          t="1656060954934"
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="9099"
                          width="16"
                          height="16"
                          @click="onStyleType(3,item.value,index,index1)"
                        >
                          <path
                            d="M202.666667 256h-42.666667a32 32 0 0 1 0-64h704a32 32 0 0 1 0 64H266.666667v565.333333a53.333333 53.333333 0 0 0 53.333333 53.333334h384a53.333333 53.333333 0 0 0 53.333333-53.333334V352a32 32 0 0 1 64 0v469.333333c0 64.8-52.533333 117.333333-117.333333 117.333334H320c-64.8 0-117.333333-52.533333-117.333333-117.333334V256z m224-106.666667a32 32 0 0 1 0-64h170.666666a32 32 0 0 1 0 64H426.666667z m-32 288a32 32 0 0 1 64 0v256a32 32 0 0 1-64 0V437.333333z m170.666666 0a32 32 0 0 1 64 0v256a32 32 0 0 1-64 0V437.333333z"
                            p-id="9100"
                            fill="#707070"
                          />
                        </svg>
                      </div>
                      <!-- 有道翻译\例句窗口   -->
                      <div v-else class="column windowType" @mouseleave="item.translation=false;">
                        <!-- 标题 -->
                        <div class="row title-div">
                          <span class="title">{{ translationWord }}</span>
                          <i v-if="isModelSentenceList" class="el-icon-loading"></i>
                        </div>
                        <!-- 有道翻译 -->
                        <iframe
                          v-if="windowType===1"
                          id="iframe"
                          ref="iframe"
                          :src="`${service}Sys/YouDaoHtml?word=${translationWord}&uid=${uid}`"
                          frameborder="0"
                          width="1000px"
                          height="380px"
                        ></iframe>
                        <!-- 例句 -->
                        <div v-else class="sentence">
                          <el-scrollbar class="scrollbar">
                            <div
                              v-for="(ms, index3) in ModelSentenceList"
                              :key="index3"
                              class="column ms-row"
                              @click.stop="osMSOpacity(index3)"
                            >
                              <span class="ms-english">
                                {{ index3+1 }}.
                                <span v-html="ms.english"></span>
                                <svg
                                  data-v-236478fb
                                  title="合成音"
                                  t="1632040636894"
                                  viewBox="0 0 1024 1024"
                                  version="1.1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  p-id="1916"
                                  width="14"
                                  height="14"
                                  style="margin-left:5px;cursor:pointer;"
                                  @click.stop="onMsPlay(1,ms.englishText)"
                                >
                                  <path
                                    data-v-236478fb
                                    d="M143.36 737.28a81.92 81.92 0 0 1-81.92-81.92V368.64a81.92 81.92 0 0 1 81.92-81.92h163.84l171.6224-148.74624A81.92 81.92 0 0 1 614.4 199.8848v624.2304a81.92 81.92 0 0 1-135.5776 61.91104L307.2 737.28H143.36z m684.83072-515.4816A358.07232 358.07232 0 0 1 962.56 501.76a358.07232 358.07232 0 0 1-134.36928 279.9616 30.72 30.72 0 0 1-38.46144-47.9232 296.63232 296.63232 0 0 0 111.4112-232.0384c0-91.40224-41.472-175.9232-111.4112-232.0384a30.72 30.72 0 1 1 38.46144-47.9232z m-114.9952 121.18016C772.7104 382.09536 808.96 444.14976 808.96 512c0 67.85024-36.2496 129.90464-95.76448 169.02144a30.72 30.72 0 1 1-33.75104-51.32288C722.3296 601.4976 747.52 558.32576 747.52 512s-25.21088-89.51808-68.07552-117.69856a30.72 30.72 0 1 1 33.75104-51.32288z"
                                    fill="#646262"
                                  />
                                </svg>
                                <svg
                                  v-if="ms.video"
                                  data-v-236478fb
                                  title="原音"
                                  t="1632040636894"
                                  viewBox="0 0 1024 1024"
                                  version="1.1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  p-id="1916"
                                  width="14"
                                  height="14"
                                  style="margin-left:5px;cursor:pointer;"
                                  @click.stop="onMsPlay(2,ms)"
                                >
                                  <path
                                    data-v-236478fb
                                    d="M143.36 737.28a81.92 81.92 0 0 1-81.92-81.92V368.64a81.92 81.92 0 0 1 81.92-81.92h163.84l171.6224-148.74624A81.92 81.92 0 0 1 614.4 199.8848v624.2304a81.92 81.92 0 0 1-135.5776 61.91104L307.2 737.28H143.36z m684.83072-515.4816A358.07232 358.07232 0 0 1 962.56 501.76a358.07232 358.07232 0 0 1-134.36928 279.9616 30.72 30.72 0 0 1-38.46144-47.9232 296.63232 296.63232 0 0 0 111.4112-232.0384c0-91.40224-41.472-175.9232-111.4112-232.0384a30.72 30.72 0 1 1 38.46144-47.9232z m-114.9952 121.18016C772.7104 382.09536 808.96 444.14976 808.96 512c0 67.85024-36.2496 129.90464-95.76448 169.02144a30.72 30.72 0 1 1-33.75104-51.32288C722.3296 601.4976 747.52 558.32576 747.52 512s-25.21088-89.51808-68.07552-117.69856a30.72 30.72 0 1 1 33.75104-51.32288z"
                                    fill="#c61200"
                                  />
                                </svg>
                                <i
                                  v-if="ms.isMsLoading"
                                  class="el-icon-loading"
                                  style="margin-left:5px;"
                                ></i>
                              </span>
                              <span class="ms-chinese">
                                <span v-html="ms.chinese"></span>
                              </span>
                              <span class="ms-provenance">{{ ms.grouping }}({{ ms.name }})</span>
                            </div>
                            <!-- 无数据 -->
                            <div v-if="ModelSentenceList.length==0" class="column notData">
                              <svg
                                t="1656141358753"
                                class="icon"
                                viewBox="0 0 1567 1024"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                p-id="5040"
                                width="200"
                                height="200"
                              >
                                <path
                                  d="M156.662278 699.758173h21.097186A10.444152 10.444152 0 0 1 187.994733 710.202325c0 5.765172-4.490985 10.444152-10.235269 10.444152H156.662278v21.097186A10.444152 10.444152 0 0 1 146.218126 751.978932a10.277045 10.277045 0 0 1-10.444152-10.235269V720.646477H114.676787A10.444152 10.444152 0 0 1 104.441518 710.202325c0-5.765172 4.490985-10.444152 10.235269-10.444152H135.773974v-21.097187A10.444152 10.444152 0 0 1 146.218126 668.425717c5.765172 0 10.444152 4.490985 10.444152 10.235269v21.097187z m1378.628042-83.553215v-21.097186A10.277045 10.277045 0 0 0 1524.846168 584.872503a10.444152 10.444152 0 0 0-10.444152 10.235269v21.097186h-21.097186a10.277045 10.277045 0 0 0-10.235269 10.444152c0 5.598065 4.595427 10.444152 10.235269 10.444152h21.097186v21.097187c0 5.744284 4.67898 10.235269 10.444152 10.235268a10.444152 10.444152 0 0 0 10.444152-10.235268V637.093262h21.097187c5.744284 0 10.235269-4.67898 10.235268-10.444152a10.444152 10.444152 0 0 0-10.235268-10.444152H1535.29032zM776.460024 960.861969H250.596979A20.80475 20.80475 0 0 1 229.77134 939.973665c0-11.530344 9.462402-20.888304 20.825639-20.888303h94.728457A83.010119 83.010119 0 0 1 334.212859 877.413196v-605.96969A83.49055 83.49055 0 0 1 417.849627 187.994733H480.430984V167.001988A83.49055 83.49055 0 0 1 564.067752 83.553215h501.152182A83.448773 83.448773 0 0 1 1148.856702 167.001988v605.969689c0 15.185797-4.052331 29.410732-11.133466 41.672166h115.554096c11.551232 0 20.909192 9.274407 20.909192 20.888304 0 11.530344-9.295295 20.888304-20.888304 20.888304H1002.638576v20.992745c0 15.185797-4.052331 29.410732-11.133466 41.672166h11.196131c11.488567 0 20.825639 9.274407 20.825639 20.888303 0 11.530344-9.462402 20.888304-20.825639 20.888304h-109.893365c9.545955 16.000441 7.478013 36.972297-6.41271 50.863019a41.672166 41.672166 0 0 1-59.072122 0L776.460024 960.861969z m76.367638-41.776607h66.424806c22.977134 0 41.609501-18.59059 41.609501-41.881049V270.461756c0-22.559368-18.047494-40.690416-40.314426-40.690416H416.303892c-22.266932 0-40.314426 18.214601-40.314426 40.690416v606.742557c0 23.123352 18.799473 41.881049 41.588613 41.881049h317.084449l-10.736588-10.757477a41.693054 41.693054 0 0 1-10.861918-40.377091l-19.718558-19.739447A146.259902 146.259902 0 0 1 502.363703 627.693525a146.218126 146.218126 0 0 1 220.517822 190.981761l19.739447 19.739447a41.630389 41.630389 0 0 1 40.377091 10.841029L852.827662 919.085362zM1002.638576 814.643843h62.852906A41.797496 41.797496 0 0 0 1107.080095 772.867236V167.106429c0-23.14424-18.632367-41.776607-41.588613-41.776607H563.775316A41.797496 41.797496 0 0 0 522.207592 167.106429v20.888304h396.794216A83.448773 83.448773 0 0 1 1002.638576 271.443506V814.643843zM266.325872 46.998683h31.123572c8.773088 0 15.875111 6.955805 15.875111 15.666228 0 8.647758-7.102023 15.666228-15.875111 15.666228h-31.123572v31.123572c0 8.773088-6.955805 15.875111-15.666228 15.875111a15.770669 15.770669 0 0 1-15.666228-15.875111V78.331139H203.869844A15.728893 15.728893 0 0 1 187.994733 62.664911c0-8.647758 7.102023-15.666228 15.875111-15.666228h31.123572V15.875111c0-8.773088 6.955805-15.875111 15.666228-15.875111 8.647758 0 15.666228 7.102023 15.666228 15.875111v31.123572zM20.888304 939.973665c0-11.530344 9.462402-20.888304 20.825638-20.888303h125.455152c11.488567 0 20.825639 9.274407 20.825639 20.888303 0 11.530344-9.462402 20.888304-20.825639 20.888304H41.713942A20.80475 20.80475 0 0 1 20.888304 939.973665z m658.733544-135.021995a104.441518 104.441518 0 1 0-147.722083-147.722083 104.441518 104.441518 0 0 0 147.722083 147.722083zM459.542681 313.324555a20.888304 20.888304 0 0 1 20.867415-20.888304H710.202325a20.888304 20.888304 0 1 1 0 41.776608H480.430984A20.825639 20.825639 0 0 1 459.542681 313.324555z m0 104.441518c0-11.530344 9.295295-20.888304 20.742085-20.888303h334.505295c11.44679 0 20.742086 9.274407 20.742086 20.888303 0 11.530344-9.295295 20.888304-20.742086 20.888304H480.284766A20.762974 20.762974 0 0 1 459.542681 417.766073z m0 104.441519c0-11.530344 9.316183-20.888304 20.846527-20.888304h146.301679c11.509455 0 20.846527 9.274407 20.846527 20.888304 0 11.530344-9.316183 20.888304-20.846527 20.888303h-146.301679A20.80475 20.80475 0 0 1 459.542681 522.207592zM62.664911 396.87777a62.664911 62.664911 0 1 1 0-125.329822 62.664911 62.664911 0 0 1 0 125.329822z m0-31.332456a31.332456 31.332456 0 1 0 0-62.664911 31.332456 31.332456 0 0 0 0 62.664911zM1357.739739 271.547948a62.664911 62.664911 0 1 1 0-125.329822 62.664911 62.664911 0 0 1 0 125.329822z m0-31.332456a31.332456 31.332456 0 1 0 0-62.664911 31.332456 31.332456 0 0 0 0 62.664911z"
                                  fill="#8a8a8a"
                                  p-id="5041"
                                />
                              </svg>
                              未搜索到数据!
                            </div>
                          </el-scrollbar>
                        </div>
                      </div>
                    </div>
                    <span
                      :class="{'hollow-hide':item.isSelect && item.styleType==2, 'hollow-hide-prominent': item.isProminent && item.isSelect && item.styleType==2, // 挖空样式
                               // 滑词样式
                               'smooth': item.isSelect && item.styleType==1 }"
                      class="hollow-word"
                      @mouseover="onHollowMouseover(index,index1,item)"
                      @mouseleave="onHollowMouseleave(index,index1,item)"
                      @mousedown="isHollowDown=true;onHollowMousedown(index,index1,item);"
                      @mouseup="isHollowDown=false;"
                    >{{ item.word }}</span>
                  </el-tooltip>
                  <span
                    :class="{'hollow-hide-division':(item.isDivision && (index1 < tr.list.length-1 && tr.list[index1 + 1].isSelect && tr.list[index1 + 1].type === 2) && item.type === 2 && item.styleType==2),// 挖空样式
                             // 滑词样式
                             'smooth': item.isSelect && item.styleType==1 }"
                    class="hollow-blank"
                    @mouseover="onHollowMouseover(index,index1,item)"
                    @mouseleave="onHollowMouseleave(index,index1,item)"
                    @mousedown="isHollowDown=true;onHollowMousedown(index,index1,item);"
                    @mouseup="isHollowDown=false;"
                  >&nbsp;</span>
                </div>
              </div>
              <span class="word">{{ tr.dst }}</span>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </el-main>
    <!-- 列表 -->
    <el-aside width="300px" style="padding: 20px;">
      <div style="background: white;border-radius: 6px;height: 100%;">
        <el-scrollbar class="scrollbar" style>
          <span style="font-size:12px;margin: 20px;font-weight: bold;">保存的译文</span>
          <div
            v-for="(item,index) in logList"
            :key="index"
            :ref="index"
            class="column list"
            :class="{ 'is-active-list': item.rid === rid }"
            @click.stop="onInfo(item.rid)"
            @mouseover="item.isBut=true"
            @mouseleave="item.isBut=false"
          >
            <span v-if="!item.isEditor" class="t1" style="width: calc(100% - 45px);">{{ item.name }}</span>
            <el-input v-else v-model="item.newName" placeholder="请输入名称">
              <el-button
                slot="append"
                icon="el-icon-check"
                @click.stop="onEditorName(item.rid,item)"
              />
              <el-button slot="append" icon="el-icon-close" @click.stop="item.isEditor=false" />
            </el-input>
            <span class="t2">{{ item.describe }}</span>
            <span class="t3">{{ item.time }}</span>
            <!-- 操作按钮 -->
            <div v-if="item.isBut && !item.isEditor" class="row editor">
              <svg
                t="1656086513845"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="16608"
                width="14"
                height="14"
                style="margin-right: 5px;"
                @click="item.isEditor=true"
              >
                <path
                  d="M984.772923 951.729231H39.227077a35.603692 35.603692 0 0 0-35.288615 36.115692c0 20.086154 15.675077 36.155077 35.288615 36.155077h949.444923a35.603692 35.603692 0 0 0 35.328-36.155077c-3.938462-16.029538-19.613538-36.115692-39.227077-36.115692zM35.328 843.303385H204.012308c7.876923 0 19.613538-4.017231 23.552-12.051693L808.172308 236.937846c15.714462-16.068923 15.714462-36.155077 0-52.224L643.426462 12.051692c-15.675077-16.068923-35.288615-16.068923-51.003077 0l-117.681231 120.477539L11.776 606.365538c-7.876923 8.034462-11.776 16.068923-11.776 24.103385v172.662154c0 8.034462 3.938462 20.086154 11.776 28.120615 3.938462 8.034462 15.675077 12.051692 23.552 12.051693zM615.975385 88.339692l117.68123 120.477539-66.678153 68.253538-117.720616-120.477538 66.717539-68.253539zM74.555077 646.537846L502.153846 208.817231l117.681231 120.477538L192.236308 767.015385H74.555077v-120.516923z"
                  p-id="16609"
                  fill="#999999"
                />
              </svg>
              <svg
                t="1656134009322"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="1882"
                width="14"
                height="14"
                @click.stop="onDeletes(item.rid)"
              >
                <path
                  d="M202.666667 256h-42.666667a32 32 0 0 1 0-64h704a32 32 0 0 1 0 64H266.666667v565.333333a53.333333 53.333333 0 0 0 53.333333 53.333334h384a53.333333 53.333333 0 0 0 53.333333-53.333334V352a32 32 0 0 1 64 0v469.333333c0 64.8-52.533333 117.333333-117.333333 117.333334H320c-64.8 0-117.333333-52.533333-117.333333-117.333334V256z m224-106.666667a32 32 0 0 1 0-64h170.666666a32 32 0 0 1 0 64H426.666667z m-32 288a32 32 0 0 1 64 0v256a32 32 0 0 1-64 0V437.333333z m170.666666 0a32 32 0 0 1 64 0v256a32 32 0 0 1-64 0V437.333333z"
                  p-id="1883"
                  fill="#999999"
                />
              </svg>
            </div>
          </div>
          <div v-if="logList.length==0" class="column notData">
            <svg
              t="1656141358753"
              class="icon"
              viewBox="0 0 1567 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="5040"
              width="200"
              height="200"
            >
              <path
                d="M156.662278 699.758173h21.097186A10.444152 10.444152 0 0 1 187.994733 710.202325c0 5.765172-4.490985 10.444152-10.235269 10.444152H156.662278v21.097186A10.444152 10.444152 0 0 1 146.218126 751.978932a10.277045 10.277045 0 0 1-10.444152-10.235269V720.646477H114.676787A10.444152 10.444152 0 0 1 104.441518 710.202325c0-5.765172 4.490985-10.444152 10.235269-10.444152H135.773974v-21.097187A10.444152 10.444152 0 0 1 146.218126 668.425717c5.765172 0 10.444152 4.490985 10.444152 10.235269v21.097187z m1378.628042-83.553215v-21.097186A10.277045 10.277045 0 0 0 1524.846168 584.872503a10.444152 10.444152 0 0 0-10.444152 10.235269v21.097186h-21.097186a10.277045 10.277045 0 0 0-10.235269 10.444152c0 5.598065 4.595427 10.444152 10.235269 10.444152h21.097186v21.097187c0 5.744284 4.67898 10.235269 10.444152 10.235268a10.444152 10.444152 0 0 0 10.444152-10.235268V637.093262h21.097187c5.744284 0 10.235269-4.67898 10.235268-10.444152a10.444152 10.444152 0 0 0-10.235268-10.444152H1535.29032zM776.460024 960.861969H250.596979A20.80475 20.80475 0 0 1 229.77134 939.973665c0-11.530344 9.462402-20.888304 20.825639-20.888303h94.728457A83.010119 83.010119 0 0 1 334.212859 877.413196v-605.96969A83.49055 83.49055 0 0 1 417.849627 187.994733H480.430984V167.001988A83.49055 83.49055 0 0 1 564.067752 83.553215h501.152182A83.448773 83.448773 0 0 1 1148.856702 167.001988v605.969689c0 15.185797-4.052331 29.410732-11.133466 41.672166h115.554096c11.551232 0 20.909192 9.274407 20.909192 20.888304 0 11.530344-9.295295 20.888304-20.888304 20.888304H1002.638576v20.992745c0 15.185797-4.052331 29.410732-11.133466 41.672166h11.196131c11.488567 0 20.825639 9.274407 20.825639 20.888303 0 11.530344-9.462402 20.888304-20.825639 20.888304h-109.893365c9.545955 16.000441 7.478013 36.972297-6.41271 50.863019a41.672166 41.672166 0 0 1-59.072122 0L776.460024 960.861969z m76.367638-41.776607h66.424806c22.977134 0 41.609501-18.59059 41.609501-41.881049V270.461756c0-22.559368-18.047494-40.690416-40.314426-40.690416H416.303892c-22.266932 0-40.314426 18.214601-40.314426 40.690416v606.742557c0 23.123352 18.799473 41.881049 41.588613 41.881049h317.084449l-10.736588-10.757477a41.693054 41.693054 0 0 1-10.861918-40.377091l-19.718558-19.739447A146.259902 146.259902 0 0 1 502.363703 627.693525a146.218126 146.218126 0 0 1 220.517822 190.981761l19.739447 19.739447a41.630389 41.630389 0 0 1 40.377091 10.841029L852.827662 919.085362zM1002.638576 814.643843h62.852906A41.797496 41.797496 0 0 0 1107.080095 772.867236V167.106429c0-23.14424-18.632367-41.776607-41.588613-41.776607H563.775316A41.797496 41.797496 0 0 0 522.207592 167.106429v20.888304h396.794216A83.448773 83.448773 0 0 1 1002.638576 271.443506V814.643843zM266.325872 46.998683h31.123572c8.773088 0 15.875111 6.955805 15.875111 15.666228 0 8.647758-7.102023 15.666228-15.875111 15.666228h-31.123572v31.123572c0 8.773088-6.955805 15.875111-15.666228 15.875111a15.770669 15.770669 0 0 1-15.666228-15.875111V78.331139H203.869844A15.728893 15.728893 0 0 1 187.994733 62.664911c0-8.647758 7.102023-15.666228 15.875111-15.666228h31.123572V15.875111c0-8.773088 6.955805-15.875111 15.666228-15.875111 8.647758 0 15.666228 7.102023 15.666228 15.875111v31.123572zM20.888304 939.973665c0-11.530344 9.462402-20.888304 20.825638-20.888303h125.455152c11.488567 0 20.825639 9.274407 20.825639 20.888303 0 11.530344-9.462402 20.888304-20.825639 20.888304H41.713942A20.80475 20.80475 0 0 1 20.888304 939.973665z m658.733544-135.021995a104.441518 104.441518 0 1 0-147.722083-147.722083 104.441518 104.441518 0 0 0 147.722083 147.722083zM459.542681 313.324555a20.888304 20.888304 0 0 1 20.867415-20.888304H710.202325a20.888304 20.888304 0 1 1 0 41.776608H480.430984A20.825639 20.825639 0 0 1 459.542681 313.324555z m0 104.441518c0-11.530344 9.295295-20.888304 20.742085-20.888303h334.505295c11.44679 0 20.742086 9.274407 20.742086 20.888303 0 11.530344-9.295295 20.888304-20.742086 20.888304H480.284766A20.762974 20.762974 0 0 1 459.542681 417.766073z m0 104.441519c0-11.530344 9.316183-20.888304 20.846527-20.888304h146.301679c11.509455 0 20.846527 9.274407 20.846527 20.888304 0 11.530344-9.316183 20.888304-20.846527 20.888303h-146.301679A20.80475 20.80475 0 0 1 459.542681 522.207592zM62.664911 396.87777a62.664911 62.664911 0 1 1 0-125.329822 62.664911 62.664911 0 0 1 0 125.329822z m0-31.332456a31.332456 31.332456 0 1 0 0-62.664911 31.332456 31.332456 0 0 0 0 62.664911zM1357.739739 271.547948a62.664911 62.664911 0 1 1 0-125.329822 62.664911 62.664911 0 0 1 0 125.329822z m0-31.332456a31.332456 31.332456 0 1 0 0-62.664911 31.332456 31.332456 0 0 0 0 62.664911z"
                fill="#8a8a8a"
                p-id="5041"
              />
            </svg>
            你的阅读记录还是空的哦!
          </div>
        </el-scrollbar>
      </div>
    </el-aside>
  </el-container>
</template>

<script>
import Vue from 'vue'
import { baiduTranslate } from '@/apis/sys'
import { add, list, info, editorName, deletes } from '@/apis/reading'
import { modelSentence } from '@/apis/subtitle'
import router from '@/router'
export default {
  name: 'Index',
  components: {},
  data() {
    return {
      service: Vue.$conf.service[Vue.$conf.environment],
      uid: Vue.$conf.userInfo.id,
      isEditor: true, // 是否可以编辑
      isHollowDown: false, // 挖空字幕鼠标是否按下
      hollowDownIndex: 0, // 挖空字幕鼠标按下索引
      textarea: '',
      translation: false,
      transResult: [],
      isTran: false,
      windowType: 1, // 翻译、例句窗口类型
      translationWord: '', // 翻译内容
      contentHeight: 0, // 内容区高度
      logList: [], // 记录列表
      newName: '', // 记录名称
      rid: '',
      audio: {}, // 音频播放
      ModelSentenceList: [], // 例句集合
      isModelSentenceList: false
    }
  },
  mounted() {
    this.audio = new Audio()
    this.contentHeight = document.documentElement.clientHeight - 85
    this.list()
  },
  created() {
    var that = this
    // 窗口变化
    window.onresize = function() {
      that.contentHeight = document.documentElement.clientHeight - 85
    }
    var jurisdiction = JSON.parse(localStorage.getItem('user')).jurisdiction
    if (!jurisdiction.menus['r']) {
      router.push({
        name: 'Noaccess'
      })
      return
    }
  },
  methods: {
    // 翻译
    onTranslate() {
      var taht = this
      if (taht.transResult.length > 0) return
      this.isTran = true
      var original = this.textarea
      taht.transResult = []
      original = original.replace(/\./g, '.\n')
      baiduTranslate({ original: original }).then(res => {
        res.data.trans_result.forEach(function(item, index) {
          var wordList = item.src.trim().split(' ')
          var row = []
          wordList.forEach(function(word, index) {
            row.push({
              word: word, // 单词
              translation: false, // 翻译窗口
              isSelect: false, // 是否选择
              isDivision: false, // 连接线
              value: 0, // 控制二次滑词
              type: 0, // 单词或语块 区别中间的链接线是否显示
              isProminent: false, // 已选择的单词临时显示
              styleType: 1 // 样式类型（1:滑词 2:挖空）
            })
          })
          taht.transResult.push({
            list: row,
            dst: item.dst.trim(),
            value: 0
          })
        })
        this.isTran = false
        // console.log(taht.transResult)
      })
    },
    // 切换
    onTranslationChange() {
      if (this.translation) {
        this.onTranslate()
      }
    },
    // 字幕单词移入
    onHollowMouseover(row, index, item) {
      if (!this.isHollowDown) {
        var obj = this.transResult[row].list[index]
        // 非鼠标按下状态
        if (obj.type === 1 && obj.isSelect) {
          obj.isProminent = true
        } else if (obj.type === 2 && obj.isSelect) {
          // 从左至右开始显示
          for (let i = index; i < this.transResult[row].list.length; i++) {
            var objI = this.transResult[row].list[i]
            if (objI.type === 2 && objI.isSelect) {
              objI.isProminent = true
            } else {
              break
            }
          }
          // 从右至左开始显示
          for (var i = 0; i <= index; i++) {
            var objIs = this.transResult[row].list[index - i]
            if (objIs.type === 2 && objIs.isSelect) {
              objIs.isProminent = true
            } else {
              break
            }
          }
        }
        return
      }
      // 滑词逻辑
      this.transResult[row].list[this.hollowDownIndex].type = 2 // 标记为滑词单词
      if (this.hollowDownIndex <= index) {
        // 右滑
        for (let i = 0; i < this.transResult[row].list.length; i++) {
          // 标记选择
          if (i >= this.hollowDownIndex && i <= index) {
            this.transResult[row].list[i].value = this.transResult[row].value
            this.transResult[row].list[i].type = 2
            this.transResult[row].list[i].isSelect = true
            this.transResult[row].list[i].isDivision = true
            this.transResult[row].list[i].styleType = 1
          } else {
            // 取消选择
            if (
              this.transResult[row].list[i].value ===
              this.transResult[row].value
            ) {
              this.transResult[row].list[i].type = 0
              this.transResult[row].list[i].isSelect = false
              this.transResult[row].list[i].isDivision = false
            }
          }
        }
      } else {
        // 左滑
        for (let i = 0; i < this.transResult[row].list.length; i++) {
          if (i <= this.hollowDownIndex && i >= index) {
            this.transResult[row].list[i].value = this.transResult[row].value
            this.transResult[row].list[i].type = 2
            this.transResult[row].list[i].isSelect = true
            this.transResult[row].list[i].isDivision = true
            this.transResult[row].list[i].styleType = 1
          } else {
            if (
              this.transResult[row].list[i].value ===
              this.transResult[row].value
            ) {
              this.transResult[row].list[i].type = 0
              this.transResult[row].list[i].isSelect = false
              this.transResult[row].list[i].isDivision = false
            }
          }
        }
      }
    },
    // 挖空字幕单词移出
    onHollowMouseleave(row, index, item) {
      if (!this.isHollowDown) {
        // 非鼠标按下状态
        if (
          this.transResult[row].list[index].type === 1 &&
          this.transResult[row].list[index].isSelect
        ) {
          this.transResult[row].list[index].isProminent = false
        } else if (
          this.transResult[row].list[index].type === 2 &&
          this.transResult[row].list[index].isSelect
        ) {
          // 从左至右开始显示
          for (let i = index; i < this.transResult[row].list.length; i++) {
            if (
              this.transResult[row].list[i].type === 2 &&
              this.transResult[row].list[i].isSelect
            ) {
              this.transResult[row].list[i].isProminent = false
            } else {
              break
            }
          }
          // 从右至左开始显示
          for (var i = 0; i <= index; i++) {
            if (
              this.transResult[row].list[index - i].type === 2 &&
              this.transResult[row].list[index - i].isSelect
            ) {
              this.transResult[row].list[index - i].isProminent = false
            } else {
              break
            }
          }
        }
        return
      }
    },
    // 挖空字幕单词按下
    onHollowMousedown(row, index, item) {
      if (item.isSelect) return
      this.hollowDownIndex = index
      for (let i = 0; i < this.transResult[row].list.length; i++) {
        if (i === index) {
          this.transResult[row].list[i].isSelect = !this.transResult[row].list[
            i
          ].isSelect
          this.transResult[row].list[i].isDivision = !this.transResult[row]
            .list[i].isDivision
          this.transResult[row].list[i].type = 1 // 标记为按下单词
          this.transResult[row].list[i].isProminent = false
          this.transResult[row].value += 1
          this.transResult[row].list[i].value = this.transResult[row].value
        } else {
          this.transResult[row].list[i].isProminent = false
        }
      }
    },
    // 样式功能按钮
    onStyleType(type, value, row, column, item) {
      var that = this
      switch (type) {
        // 挖空
        case 1:
          that.transResult[row].list.forEach(function(obj, index) {
            if (obj.value === value) {
              obj.styleType = 2
            }
          })
          break
        // 翻译
        case 2:
          that.translationWord = ''
          that.transResult[row].list.forEach(function(obj, index) {
            if (obj.value === value && obj.isSelect) {
              that.translationWord += obj.word + ' '
            }
          })
          that.$nextTick(() => {
            that.$refs['tooltip' + column].forEach(function(obj, index) {
              obj.updatePopper()
            })
          })
          break
        // 删除
        case 3:
          that.transResult[row].list.forEach(function(obj, index) {
            if (obj.value === value) {
              obj.isSelect = false
              obj.isDivision = false
              obj.type = 0
              obj.isProminent = false
              obj.styleType = 1
            }
          })
          break
        case 4:
          that.translationWord = ''
          that.transResult[row].list.forEach(function(obj, index) {
            if (obj.value === value && obj.isSelect) {
              that.translationWord += obj.word + ' '
            }
          })
          if (that.translationWord.length > 40) {
            this.$message({
              message: '例句关键字不能超过40字',
              type: 'warning'
            })
            return
          }
          item.translation = true
          this.onModelSentence(that.translationWord)
          that.$nextTick(() => {
            that.$refs['tooltip' + column].forEach(function(obj, index) {
              obj.updatePopper()
            })
          })
          break
      }
    },
    // 保存
    onAdd() {
      add({
        Rid: this.rid,
        Name: this.newName,
        Original: this.textarea,
        Translation: JSON.stringify(this.transResult)
      }).then(res => {
        this.list()
        this.$message({
          message: '保存成功',
          type: 'success'
        })
      })
    },
    // 记录列表
    list() {
      list().then(res => {
        res.data.forEach(function(item, index) {
          item.isBut = false
          item.isEditor = false
          item.newName = item.name
        })
        this.logList = res.data
      })
    },
    // 详情
    onInfo(rid) {
      var that = this
      that.isTran = true
      info({ rid: rid }).then(res => {
        that.textarea = res.data.original
        that.transResult = JSON.parse(res.data.translation)
        that.rid = res.data.id
        that.isTran = false
        that.isEditor = false
        that.transResult.forEach(function(row, index) {
          row.list.forEach(function(column, index) {
            column.translation = false
          })
        })
      })
    },
    // 编辑名称
    onEditorName(rid, obj) {
      editorName({ rid, name: obj.newName }).then(res => {
        obj.isEditor = false
        obj.name = obj.newName
        this.$message({
          message: '保存成功',
          type: 'success'
        })
      })
    },
    // 删除记录
    onDeletes(rid) {
      deletes({ rid }).then(res => {
        this.list()
        this.rid = ''
        this.transResult = []
        this.textarea = ''
        this.isEditor = true
        this.$message({
          message: '删除成功',
          type: 'success'
        })
      })
    },
    // 搜索字幕例句
    onModelSentence(word) {
      word = word.trim()
      this.ModelSentenceList = []
      this.isModelSentenceList = true
      // 查询例句
      modelSentence({ word: word }).then(res => {
        for (let index = 0; index < res.data.length; index++) {
          const element = res.data[index]
          element.englishText = element.english
          var reg = new RegExp(`\\b${word}\\b`, 'i', 'g')
          element.english = element.english.replace(
            reg,
            `<span style="color: #00a803;opacity: 0;"  id="msword${index}">${word}</span>`
          )
          element.english = `<span style="cursor:pointer;opacity: 0;" id="msEnglish${index}">${element.english}</span>`
          if (element.chinese === null) {
            element.chinese = '无中文字幕'
          }
          element.chinese = `<span style="cursor:pointer;opacity: 0;" id="msChinese${index}">${element.chinese}</span>`
          element.isMsLoading = false
        }
        this.ModelSentenceList = res.data
        this.isModelSentenceList = false
      })
    },
    // 合成例句发音
    onMsPlay(type, obj) {
      var that = this
      if (type === 1) {
        this.audio.src = `http://dict.youdao.com/speech?audio=${obj}`
        this.audio.play()
      } else if (type === 2) {
        console.log(obj)
        obj.isMsLoading = true
        this.audio.src = obj.audio
        this.audio.currentTime = obj.startMillisecond / 1000
        var audioTimeupdate = function(event) {
          if (that.audio.currentTime >= obj.endMillisecond / 1000) {
            that.audio.pause()
            that.audio.removeEventListener('timeupdate', audioTimeupdate)
            that.audio.removeEventListener('canplay', canplay)
          }
        }
        var canplay = function() {
          obj.isMsLoading = false
        }
        this.audio.play()
        this.audio.addEventListener('timeupdate', audioTimeupdate)
        this.audio.addEventListener('canplay', canplay)
      }
    },
    // 例句隐藏
    osMSOpacity(index) {
      if (document.getElementById('msEnglish' + index).style.opacity !== '1') {
        document.getElementById('msEnglish' + index).style.opacity = 1
      } else if (
        document.getElementById('msword' + index).style.opacity !== '1'
      ) {
        document.getElementById('msword' + index).style.opacity = 1
      } else if (
        document.getElementById('msChinese' + index).style.opacity !== '1'
      ) {
        document.getElementById('msChinese' + index).style.opacity = 1
      } else {
        document.getElementById('msEnglish' + index).style.opacity = 0
        document.getElementById('msword' + index).style.opacity = 0
        document.getElementById('msChinese' + index).style.opacity = 0
      }
      // // 原生事件 阻止冒泡
      // window.event.cancelBubble = true
    }
  }
}
</script>

<style lang="less" scoped>
//禁止文本选择
* {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}
.row {
  display: flex;
  flex-direction: row;
}
.column {
  display: flex;
  flex-direction: column;
}
.notData {
  font-size: 12px;
  color: #8a8a8a;
  // 左右上下居中
  display: flex;
  justify-content: center;
  align-items: center;
}
.content {
  background: #FFFFFF;
  border-radius: 6px;
  // height: 100%;
  // padding: 40px;
  .title {
    margin-left: 10px;
    margin-top: 10px;
    // 左右上下居中
    display: flex;
    // justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }
  span {
    font-size: 12px;
    color: #333333;
  }
  .tran {
    margin-left: 10px;
    font-size: 12px;
    color: #333333;
    display: flex;
    align-items: center;
    span {
      margin: 0 5px;
    }
  }
}
.original-input {
  height: 100%;
}
.original-trans {
  height: calc(100% - 40px) ;
  .trans {
    padding: 10px 0px;
    .word {
      width: 50%;
      background: white;
      padding: 10px;
      flex-flow: wrap;
    }
    .hollow-word {
      cursor: pointer;
      border-width: 2px 0px 2px 0px;
      border-style: solid;
      border-color: transparent;
    }
    .hollow-blank {
      cursor: pointer;
      border-width: 2px 0px 2px 0px;
      border-style: solid;
      border-color: transparent;
    }
    // 滑词样式 背景黄色 字体黑色
    .smooth {
      background: #f7dc00 !important;
      color: #282828 !important;
    }

    // 挖空样式 字体透明 边框红色
    .hollow-hide {
      color: transparent;
      border-bottom-color: #c71100 !important;
    }
    // 挖空样式 鼠标移入颜色
    .hollow-hide-prominent {
      color: black !important;
    }
    // 挖空样式 链接线样式 字体透明 边框黄色
    .hollow-hide-division {
      color: transparent;
      border-bottom-color: #dbff00 !important;
    }
  }
}
.scrollbar {
  height: 100%;
  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
.list {
  background: #F7F7F7;
  margin: 20px 20px 20px 20px;
  padding: 2px 6px;
  position: relative;
  .t1 {
    color: #333333;
    font-size: 14px;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: keep-all;
  }
  .t2 {
    color: #333333;
    font-size: 12px;
    margin-top: 5px;
    margin-bottom: 3px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: keep-all;
  }
  .t3 {
    color: #666666;
    font-size: 12px;
  }
  .editor {
    position: absolute;
    right: 5px;
    bottom: 5px;
  }
}
.is-active-list {
  background: #e7e7e7 !important;
}
.windowType {
  height: 400px;
  width: 800px;
  overflow: hidden;
  .title-div {
    // 左右上下居中
    display: flex;
    // justify-content: center;
    align-items: center;
    .title {
      border-radius: 2px;
      background: #f7dc00;
      color: #282828;
      font-size: 12px;
      padding: 2px 10px;
      color: #4d4d4d;
      max-width: calc(100% - 40px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: keep-all;
    }
    i {
      margin-left: 5px;
    }
  }
  .sentence {
    height: calc(100% - 20px);
  }
}
// 例句
.ms-row {
  margin: 10px 0px;
  padding: 5px;
  border-width: 0 0 1px 0;
  border-color: #f9f6f6;
  border-style: solid;
  .ms-english {
    font-weight: bold;
    display: flex;
    align-items: center;
    // justify-content: center;
    color: #646262;
    font-size: 14px;
    margin-bottom: 5px;
  }

  .ms-chinese {
    color: #7d7d7d;
    font-size: 11px;
    margin-bottom: 5px;
  }

  .ms-provenance {
    font-size: 10px;
    color: #9d9d9d;
  }
}
</style>

<style>
html {
  background: #1c1c1c !important;
}
.el-textarea__inner {
  min-height: 100% !important;
  background-color: #ffffff !important;
  color: #333333 !important;
  border-width: 0px !important;
}
.el-switch.is-checked .el-switch__core::after {
  margin-left: -13px !important;
}
.el-switch__core:after {
  width: 12px !important;
  height: 12px !important;
}
.el-switch__core {
  height: 16px !important;
}
.el-switch__label * {
  font-size: 12px;
}
/* .el-input-group--append .el-input__inner {
  background: #717171 !important;
  color: white !important;
}
.el-input-group__append,
.el-input-group__prepend {
  background-color: #717171;
}
.el-input-group__append button.el-button,
.el-input-group__append div.el-select .el-input__inner,
.el-input-group__append div.el-select:hover .el-input__inner,
.el-input-group__prepend button.el-button,
.el-input-group__prepend div.el-select .el-input__inner,
.el-input-group__prepend div.el-select:hover .el-input__inner {
  color: white;
} */
</style>
